module.exports = __webpack_public_path__ + "img/housebox.e945d322.svg";